// extracted by mini-css-extract-plugin
export default {"actionBtn":"LVB-k","shareWrapper":"Csrqu","shareBlock":"DT1Kh"};